<template>
  <div>
    <b-card no-body>
      <div style="display:block" id="listaRequests">
        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">
            <b-card-body>
              <b-row>
                <b-col cols="12" md="6" class="mb-md-0 mb-2">
                  <b-form-group rangeDate>
                    <label>Fecha hasta</label>
                    <flat-pickr id="endDate" v-model="endDate" class="form-control" :config="{
                      dateFormat: 'Y-m-d',
                      locale: 'es',
                      maxDate: new Date(),
                    }" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </div>
        </b-card-body>
      </div>
    </b-card>

    <b-card no-body>
      <b-button @click="getInventoryCurrent" variant="primary" :disabled="isLoading">Inventario - Posiciones
        Actuales</b-button>
      <br />
      <b-button @click="getInventoryRequested" variant="primary" :disabled="isLoading">Inventario - Posiciones
        Solicitadas</b-button>
    </b-card>
    <div v-if="isLoading">
      <div class="text-center">
        <label>Cargando...</label>&nbsp;
        <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BFormGroup,
  BButton,
  BCardBody,
  VBModal,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCardBody,
    BRow,
    BCol,
    BSpinner,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      isLoading: false,
      endDate: null,
    }
  },
  mounted() {
    this.setupInitialDate()
  },
  methods: {
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    getInventoryRequested() {
      const URL2 = '/nomina/admin/inventory_requested'
      const config = {
        method: 'get',
        url: URL2,
        responseType: 'blob',
        params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
        },
      }
      this.isLoading = true
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data)

            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute('download', 'PosicionesSolicitadas.xlsx') // or any other extension
            document.body.appendChild(link)
            link.click()

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          }
          this.isLoading = false
        })
        .catch(error => {
          this.printErrorModal(error)
          this.isLoading = false
        })
    },
    getInventoryCurrent() {
      const URL2 = '/nomina/admin/inventory_current'
      const config = {
        method: 'get',
        url: URL2,
        responseType: 'blob',
        params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
          endDate: this.endDate,
        },
      }
      console.log(config)
      this.isLoading = true
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'PosicionesActuales.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          }
          this.isLoading = false
        })
        .catch(error => {
          this.printErrorModal(error)
          this.isLoading = false
        });
    },
    setupInitialDate(){
      let date = new Date()
      this.endDate= date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate()
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
